var common = require("../../utiles/common.js");

module.exports = function () {
  // 被动登录参数
  var searchUrl = sessionStorage.getItem("searchUrl")
    ? sessionStorage.getItem("searchUrl")
    : "";
  var service = sessionStorage.getItem("service");
  if (service) {
    service = searchUrl ? "&service=" + service : "?service=" + service;
  } else {
    service = "";
  }
  var isLoginUrl =
    "/auth/isAgentLogin" + (searchUrl ? "?" + searchUrl + service : service);
  console.log(isLoginUrl);
  //Windows CP自动登录
  var intervalObj = null; //计时器
  var i = 0;
  //启动计时器函数
  function startCheck() {
    if (intervalObj != null) {
      clearInterval(intervalObj);
      intervalObj = null;
    }
    intervalObj = setInterval(loginCheck, 1000); //启动计时器，调用overs函数，
  }
  function jsLogin(url) {
    // 调用子页面
    var ticket;
    if (i >= 20) {
      clearInterval(intervalObj);
      return false;
    }
    try {
      if (getLoginTicket) {
        ticket = getLoginTicket();
      }
    } catch (error) {
      console.log("获取ticket失败,需要等待或者刷新...");
    }
    if (ticket) {
      console.log(ticket);
      stopCheck();
      // 请求后台建立token
      $.ajax({
        url: url + ticket,
        success: function (data) {
          console.log(data);
          common.fetch(isLoginUrl, {
            success: function (data) {
              if (data.redirectUrl) {
                common.redirectTo(data.redirectUrl);
              }
            },
          });
        },
        error: function (result) {
          console.log(result);
        },
      });
    }
  }
  var ua = navigator.userAgent.toLowerCase();
  var os = common.validataOS();
  console.log(ua);
  function loginCheck() {
    i++;
    if (os === "Window") {
      jsLogin("/auth/browser/validate?serviceTicket=");
    } else if (os === "Linux") {
      jsLogin("/auth/pam/validateToken?token=");
    }
  }
  function stopCheck() {
    clearInterval(intervalObj);
    intervalObj = null;
  }
  //域登录
  var isWinLogout = sessionStorage.getItem("isWinLogout");
  var jsLoginUrl = "http://127.0.0.1:26262";
  if (!isWinLogout) {
    var jsPamLoginIframe =
      '<script src="' +
      jsLoginUrl +
      '/pam/agent/getToken" style="display: none"></script>';
    var jsWinLoginIframe =
      '<script id="jsWinLogin" name="jsWinLogin" src="' +
      jsLoginUrl +
      '/auth/sso/jsWinLogin" style="display: none"></script>';

    if (os === "Window") {
      $("body").append(jsWinLoginIframe);
    } else if (os === "Linux") {
      $("body").append(jsPamLoginIframe);
    }

    // 启动setInterval循环检查ticket
    startCheck();
  }
};



//////////////////
// WEBPACK FOOTER
// ./src/component/login/newCpLogin.js
// module id = 106
// module chunks = 0